module.exports = __webpack_public_path__ + "img/model_54.437e9276.jpg";